import { Facebook, Instagram, Linkedin, Mail, MapPin, Phone, Twitter } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const NAV = [
    { label: "Home", id: "#hero" },
    { label: "Services", id: "#services" },
    { label: "How It Works", id: "#how-it-works" },
    { label: "Why Reno Genie", id: "#why-reno-genie" },
    { label: "Showcase", id: "#showcase" },
];

const SERVICES = [
    "Kitchen Renovation",
    "Bathroom Renovation",
    "Interior Design",
    "Painting & Finishes",
    "Flooring Works",
    "Commercial Renovation",
];

const SOCIALS = [
    { Icon: Facebook, label: "Facebook", testid: "social-facebook" },
    { Icon: Instagram, label: "Instagram", testid: "social-instagram" },
    { Icon: Twitter, label: "Twitter", testid: "social-twitter" },
    { Icon: Linkedin, label: "LinkedIn", testid: "social-linkedin" },
];

export const Footer = () => (
    <footer id="contact" data-testid="site-footer" className="border-t border-white/10 bg-brand-deep">
        <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8 sm:py-20">
            <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
                <div className="md:col-span-4">
                    <div className="flex items-center gap-3">
                        <img src="/brand/genie.png" alt="Reno Genie mascot" className="h-14 w-auto" />
                        <div>
                            <p className="font-display text-2xl font-semibold tracking-tight text-white">
                                Reno <span className="italic text-brand-gold">Genie</span>
                            </p>
                            <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.3em] text-brand-gold/80">
                                Your Wish Made Real
                            </p>
                        </div>
                    </div>
                    <p className="mt-6 max-w-xs text-sm leading-relaxed text-white/60">
                        A modern renovation and interior services platform — connecting your wish with the
                        professionals who make it real.
                    </p>
                    <div className="mt-7 flex gap-3">
                        {SOCIALS.map((social) => (
                            <a
                                key={social.label}
                                href="#contact"
                                aria-label={social.label}
                                data-testid={social.testid}
                                onClick={(e) => e.preventDefault()}
                                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white/70 transition-all duration-300 hover:-translate-y-1 hover:border-brand-gold hover:bg-brand-gold hover:text-brand-deep"
                            >
                                <social.Icon className="h-4 w-4" />
                            </a>
                        ))}
                    </div>
                </div>

                <div className="md:col-span-2">
                    <p className="mb-5 font-mono text-[11px] font-semibold uppercase tracking-[0.24em] text-white/40">
                        Navigate
                    </p>
                    <ul className="space-y-3">
                        {NAV.map((item) => (
                            <li key={item.id}>
                                <button
                                    type="button"
                                    onClick={() => scrollToId(item.id)}
                                    data-testid={`footer-nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                                    className="text-sm text-white/70 transition-colors hover:text-brand-gold"
                                >
                                    {item.label}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="md:col-span-3">
                    <p className="mb-5 font-mono text-[11px] font-semibold uppercase tracking-[0.24em] text-white/40">
                        Services
                    </p>
                    <ul className="space-y-3">
                        {SERVICES.map((service) => (
                            <li key={service}>
                                <button
                                    type="button"
                                    onClick={() => scrollToId("#services")}
                                    className="text-sm text-white/70 transition-colors hover:text-brand-gold"
                                >
                                    {service}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="md:col-span-3">
                    <p className="mb-5 font-mono text-[11px] font-semibold uppercase tracking-[0.24em] text-white/40">
                        Contact
                    </p>
                    <ul className="space-y-4 text-sm text-white/70">
                        <li className="flex items-center gap-3" data-testid="footer-email">
                            <Mail className="h-4 w-4 shrink-0 text-brand-gold" />
                            hello@renogenie.com
                        </li>
                        <li className="flex items-center gap-3" data-testid="footer-phone">
                            <Phone className="h-4 w-4 shrink-0 text-brand-gold" />
                            +1 (555) 012-3456
                        </li>
                        <li className="flex items-start gap-3" data-testid="footer-address">
                            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand-gold" />
                            123 Genie Lane, Suite 7
                            <br />
                        </li>
                    </ul>
                </div>
            </div>

            <div className="mt-16 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row">
                <p className="text-xs text-white/45">© 2026 Reno Genie. All rights reserved.</p>
                <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/45">
                    Made with a little magic
                </p>
            </div>
        </div>
    </footer>
);
